<script>
	export default{
		methods:{
			closeProvider(){
				window.$('#search-provider').modal('hide');
			},
			selectProvider(provider){
				this.$emit('setProvider',provider);	
				window.$('#search-provider').modal('hide');
			}
			
		}
	}
</script>
<template>
	<div id="search-provider" class="modal fade" role="dialog">
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				<div class="header-modal">
					<label>Búsqueda: Formato</label>
					<div class="modal-header-buttons">
						<button type="button">
							<i class="far fa-window-maximize"></i>	
						</button>
						<button type="button" data-dismiss="modal">
							<i class="fas fa-times"></i>	
						</button>
					</div>
				</div>
				<div class="body-modal pb-30">
					<table class="table-first-gray table-row-hover">
						<tr>
							<td></td>
							<td>Interloc. cila.</td>
							<td>Usuario</td>
							<td>Nombre pila</td>
							<td>Apellido</td>
						</tr>
						<tr @click="selectProvider({usuario:'1UF1KA0', nombre:'Ana Karen Muñoz Caballero'})">
							<td>&nbsp;</td>
							<td>35055</td>
							<td>1UF1KA0</td>
							<td>Ana Karen</td>
							<td>Muñoz Caballero</td>
						</tr>
						<tr @click="selectProvider({usuario:'3FX5CB7', nombre:'Alejandro Garcia Vila'})">
							<td>&nbsp;</td>
							<td>35625</td>
							<td>3FX5CB7</td>
							<td>Alejandro</td>
							<td>Garcia Vila</td>
						</tr>
						<tr @click="selectProvider({usuario:'3VX8ZA3', nombre:'Aldo Alberto Ramirez Poletti'})">
							<td>&nbsp;</td>
							<td>35065</td>
							<td>3VX8ZA3</td>
							<td>Aldo Alberto</td>
							<td>Ramirez Poletti</td>
						</tr>
						<tr @click="selectProvider({usuario:'4BY15UC', nombre:'Magaly Sacnicté Ramírez Sánchez'})">
							<td>&nbsp;</td>
							<td>28815</td>
							<td>4BY15UC</td>
							<td>Magaly Sacnicté Ramírez</td>
							<td>Sánchez</td>
						</tr>
						<tr @click="selectProvider({usuario:'4MM1H2H', nombre:'Natalia Piña Becerril'})">
							<td>&nbsp;</td>
							<td>24181</td>
							<td>4MM1H2H</td>
							<td>Natalia</td>
							<td>Piña Becerril</td>
						</tr>
						<tr @click="selectProvider({usuario:'6XZ5W48', nombre:'Nallely Perez'})">
							<td>&nbsp;</td>
							<td>29758</td>
							<td>6XZ5W48</td>
							<td>Nallely</td>
							<td>Perez</td>
						</tr>
						<tr @click="selectProvider({usuario:'76TV7ED', nombre:'Anaid Mejia'})">
							<td>&nbsp;</td>
							<td>30558</td>
							<td>76TV7ED</td>
							<td>Anaid</td>
							<td>Mejia</td>
						</tr>
						<tr @click="selectProvider({usuario:'820PA5D', nombre:'Ricardo Silva'})">
							<td>&nbsp;</td>
							<td>42310</td>
							<td>820PA5D</td>
							<td>Ricardo</td>
							<td>Silva</td>
						</tr>
						<tr @click="selectProvider({usuario:'A0Z30HK', nombre:'Esli Yudith Mendoza'})">
							<td>&nbsp;</td>
							<td>27563</td>
							<td>A0Z30HK</td>
							<td>Esli Yudith</td>
							<td>Mendoza</td>
						</tr>
						<tr @click="selectProvider({usuario:'AP0DF7J', nombre:'Ingrid Elizabeth Osnaya Planas'})">
							<td>&nbsp;</td>
							<td>41984</td>
							<td>AP0DF7J</td>
							<td>Ingrid Elizabeth</td>
							<td>Osnaya Planas</td>
						</tr>
					</table>
				</div>
				<div class="footer-modal buttons no-bg">
					<button>Ok</button>
					<button @click="closeProvider()">Cancelar</button>
				</div>
			</div>
		</div>
	</div>
</template>








